import { ChangeColor } from './ChangeColor';

export class ChangeGreyColor extends ChangeColor {
  type: string = 'ChangeGreyColor';
}
